<template>
    <div
        :class="{
            'enhanced-dollar': true,
            'padded-page': true,
            none: reviewData?.total_edi <= 0,
        }"
        ref="screenWrapper"
    >
        <template v-if="reviewData?.total_edi > 0">
            <div class="mb-5 text-white font-satoshi_r max-w-xs">
                <p class="text-lg">You Invested a total of</p>
                <p class="text-4xl font-satoshi_b font-bold my-2">
                    <CountUpNumber :endVal="reviewData?.total_edi ?? 0" currency="$" />
                </p>
                <p>in Enhanced Dollar Investment in 2025.</p>
            </div>
            <div class="mb-5 text-white font-satoshi_r max-w-xs">
                <p class="text-lg">Sycamore paid you</p>
                <p class="text-4xl font-satoshi_b font-bold my-2">
                    <CountUpNumber :endVal="reviewData?.edi_returns ?? 0" currency="$" />
                </p>
                <p>in Investment returns.</p>
            </div>
        </template>
        <template v-else>
            <div class="mb-5 text-white font-satoshi_r max-w-xs">
                <p class="text-lg mb-6">Plant your first money seed 🌱.</p>
                <p class="text-lg">With our dollar investments, you can start from just $5 and earn up to</p>
                <p class="text-4xl font-satoshi_b font-bold my-2">8% p.a.</p>
            </div>
        </template>
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.enhanced-dollar {
    color: #fcfcde;
    min-height: 100vh;
    background-color: #4593c0;

    background-image: url("../../assets/images/year-in-review/enhanced-dollar.svg");
    background-size: 80%;
    background-repeat: no-repeat;
    background-position: bottom right;
}

.enhanced-dollar.none {
    background-image: url("../../assets/images/year-in-review/enhanced-dollar-none.svg");
}

@media (max-height: 750px) {
    .enhanced-dollar {
        background-size: 65% auto;
    }
}
</style>
